// extracted by mini-css-extract-plugin
export var chevronIcon = "_5w-2";
export var teamName = "_5w-1";
export var teamSwitcherButton = "_5w-0";